<template>
    <div class="loading">
        <div class="spinner"><div></div></div>
        <p>{{title}}</p>
        <span>{{subtitle}}</span>
    </div>
</template>
<style scoped lang="scss">
    .loading{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 2;
        flex-shrink: 2;
        height: 100%;
        padding: 2rem;
        user-select: none;
        .spinner{
            height: 65px;
            width: 65px;
            border-radius: 50%;
            margin-bottom: 1rem;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
            overflow: hidden;
            div{
                height: 100%;
                width: 100%;
                background-image: linear-gradient(45deg, #00796b, #263238);
                background-size: 250% 250%;
                transition: background-position 300ms ease, opacity 300ms ease, background-color 300ms ease, box-shadow 300ms ease;
                animation: moveBG 2.2s ease infinite, rotateBG 2s linear infinite;
                @keyframes moveBG{
                    0%{
                        background-position: 1% 1%;
                    }
                    25%{
                        background-position: 99% 1%;
                    }
                    50%{
                        background-position: 99% 99%;
                    }
                    75%{
                        background-position: 1% 99%;
                    }
                }
                @keyframes rotateBG{
                    0%{
                        transform: rotate(0deg);
                    }
                    100%{
                        transform: rotate(360deg);
                    }
                }
            }
        }
        p{
            margin: 0 0 0.8rem 0;
            font-size: 1.8rem;
            font-weight: bold;
        }
        span{
            opacity: 0;
            animation: fadein 800ms 10s forwards;
            @keyframes fadein {
                from {
                    opacity: 0;
                }

                to {
                    opacity: 0.8;
                }
            }
        }
    }
</style>
<style>
body > div.loading{
    height: 100vh !important;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
}
</style>
<script>
export default {
    name: 'Loading',
    props: {
        title: {
            default: 'Loading content',
        },
        subtitle: {
            default: 'Actions took longer than expected. Try reloading the page',
        }
    },
}
</script>